// import { List, Stack, useTheme } from '@mui/material';
// import { useAuthContext } from 'src/auth/useAuthContext';

// import { NavSectionProps } from '../types';

// import NavList from './NavList';

// // ----------------------------------------------------------------------

// export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
//   const { user } = useAuthContext();

//   const theme = useTheme();
//   const ACCESSIBLE_MENU_URI_LIST = user?.menuList.map((m: any) => m.menuUri);

//   return (
//     <Stack sx={sx} {...other}>
//       {data.map((group) => {
//         const key = group.subheader || group.items[0].title;

//         return (
//           group.items
//             .map((list) => ACCESSIBLE_MENU_URI_LIST.includes(list.path))
//             .includes(true) && (
//             <List
//               key={key}
//               disablePadding
//               sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
//             >
//               {/* {group.subheader && (
//                 <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
//               )} */}

//               {group.items.map((list) => {
//                 return (
//                   ACCESSIBLE_MENU_URI_LIST.includes(list.path) && (
//                     <NavList
//                       key={list.title + list.path}
//                       data={list}
//                       depth={1}
//                       hasChild={!!list.children}
//                     />
//                   )
//                 );
//               })}
//             </List>
//           )
//         );
//       })}
//     </Stack>
//   );
// }

import { useMemo } from 'react';
import { List, Stack, useTheme } from '@mui/material';
import { useAuthContext } from 'src/auth/useAuthContext';
import { buildMenuTree } from 'src/utils/menuUtils';

import NavList from './NavList';

// ----------------------------------------------------------------------

export default function NavSectionVertical({ sx, ...other }: any) {
  const { user } = useAuthContext();
  const theme = useTheme();

  // API 응답으로 받은 menuList를 계층 구조로 변환
  const menuTree = useMemo(() => {
    if (!user?.menuList) return [];
    return buildMenuTree(user.menuList);
  }, [user?.menuList]);

  return (
    <Stack sx={sx} {...other}>
      <List
        disablePadding
        sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
      >
        {menuTree.map((list) => (
          <NavList
            key={list.title + list.path}
            data={list}
            depth={1}
            hasChild={!!(list.children && list.children.length > 0)}
          />
        ))}
      </List>
    </Stack>
  );
}
